module.exports = __webpack_public_path__ + "c_static/img/share.15bff69.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/img/share.png
// module id = awwz
// module chunks = 33